import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let DeviceIndex = class DeviceIndex extends Vue {
};
DeviceIndex = __decorate([
    Component({
        name: 'DeviceIndex'
    })
], DeviceIndex);
export default DeviceIndex;
;
